export default {
  SET_TOKEN (state, token) {
    state.token = token
  },
  LOGOUT (state) {
    state.token = null
  },
  CLIENTS_SEARCH (state, clientsSearched, clientsSearchFields) {
    state.clientsSearched = clientsSearched,
    state.clientsSearchFields = clientsSearchFields
  },
  RESERVES_SEARCH (state, reservesSearched, reservesSearchedFields=null) {
    state.reservesSearched = reservesSearched,
    state.reservesSearchedFields = reservesSearchedFields
  }
}